<template>
    <div>
        <v-card flat>
            <v-data-table
                class="pa-3"
                :headers="headers"
                :items="ravs"
                :search="search"
                :show-select="selection"
                v-model="selectedRows"
                :footer-props="defaultFooterProps"
                :items-per-page="getPrefenceValue('rav.itemsPerPage', 25)"
                @update:items-per-page="val => setPrefenceValue('rav.itemsPerPage', val)"
                :page="currentPage"
                @update:page="page => currentPage = page"
                group-by="canton.code"
            >
                <template v-slot:group.header="{items, isOpen, toggle}">
                    <th colspan="3">
                        <v-icon
                            @click="toggle"
                        >
                            {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                        </v-icon>
                        {{ items[0].canton.name }} ({{ items[0].canton.code }})
                    </th>
                </template>
                <template v-slot:item.city="{ item }">
                    <v-btn
                        link
                        text
                        :to="{ name: 'rav_detail', params: { id: item.id }}"
                    >
                        {{ item.city }}
                    </v-btn>
                </template>
                <template v-slot:item.name="{ item }">
                    <v-btn
                        link
                        text
                        :to="{ name: 'rav_detail', params: { id: item.id }}"
                    >
                        {{ item.name }}
                    </v-btn>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                v-on="on"
                                class="mx-1"
                                :to="{ name: 'rav_detail', params: { id: item.id }}"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                        </template>
                        <span v-text="$t('general.edit')" />
                    </v-tooltip>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-dots-horizontal
                            </v-icon>
                        </template>
                        <v-list>
                            <v-list-item @click="emailAllConsultants(item)">
                                <v-list-item-action>
                                    <v-icon>mdi-email-multiple-outline</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="$t('rav.email_consultants')" />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="initiateDeletion(item)">
                                <v-list-item-action>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="$t('general.delete')" />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </v-card>
        <ConfirmationDialog
            :confirm="deleteObject"
            :cancel="() => (deleteDialog = false)"
            :loading="deleting"
            :dialog="deleteDialog"
        />
    </div>
</template>

<script>

import ConfirmationDialog from '@/components/common/ConfirmationDialog';
import RavProxy from '@/proxies/RavProxy';
import { ObjectDeleted, StandBy } from '@/app-events.js';

export default {
    name: 'RavList',
    components: {
        ConfirmationDialog,
    },
    props: {
        search: {
            type: String,
            default: '',
        },
        selection: {
            type: Boolean,
            default: false,
        },
        ravs: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            deleteDialog: false,
            deleting: false,
            objectToDelete: null,
            selectedRows: [],
            headers: [
                { 
                    text: this.$t('rav.city'),
                    value: 'city',
                    align: 'start',
                },
                {
                    text: this.$t('rav.name'),
                    value: 'name',
                },
                {
                    value: 'canton.name',
                    align: ' d-none',
                },
                { 
                    text: 'Aktionen',
                    value: 'actions',
                    sortable: false ,
                    align: 'right',
                },
            ],
        }
    },
    methods: {
        initiateDeletion(item) {
            this.objectToDelete = item;
            this.deleteDialog = true;
        },
        deleteObject() {
            this.deleting = true;
            new RavProxy().delete(this.objectToDelete.id).then(({ data }) => {
                this.$eventBus.dispatch(new ObjectDeleted({
                    object: this.objectToDelete,
                }));
            }).catch(({ data }) => {
                this.displayError(data);
            }).finally(() => {
                this.deleteDialog = false;
                this.objectToDelete = null;
                this.deleting = false;
            });
        },
        emailAllConsultants(item) {
            new RavProxy().consultantEmails(item.id).then(({ data }) => {
                let fileLink = document.createElement('a');
                fileLink.href = `mailto:${data.data.join(',')}`;
                fileLink.target = '_blank';
                document.body.appendChild(fileLink);
                fileLink.click();
                setTimeout(function() {
                    document.body.removeChild(fileLink);
                }, 200);
            }).catch(({ data }) => {
                this.displayError(data);
            });
        },
    },
    watch: {
        selectedRows(val) {
            this.$emit('selection-changed', val);
        }
    },
};
</script>
